export function EmojiPicker() {
  return import("../../emoji/emoji_picker");
}

export function Compose() {
  return import("../../compose");
}

export function Notifications() {
  return import("../../notifications_v2");
}

export function HomeTimeline() {
  return import("../../home_timeline");
}

export function PublicTimeline() {
  return import("../../public_timeline");
}

export function CommunityTimeline() {
  return import("../../community_timeline");
}

export function Firehose() {
  return import("../../firehose");
}

export function HashtagTimeline() {
  return import("../../hashtag_timeline");
}

export function ListTimeline() {
  return import("../../list_timeline");
}

export function Lists() {
  return import("../../lists");
}

export function DirectTimeline() {
  return import("../../direct_timeline");
}

export function Collections() {
  return import("../../collections").then((module) => ({ default: module.Collections }));
}

export function CollectionDetail() {
  return import("../../collections/detail/index").then((module) => ({
    default: module.CollectionDetailPage,
  }));
}

export function CollectionsEditor() {
  return import("../../collections/editor").then((module) => ({
    default: module.CollectionEditorPage,
  }));
}

export function Status() {
  return import("../../status");
}

export function GettingStarted() {
  return import("../../getting_started");
}

export function KeyboardShortcuts() {
  return import("../../keyboard_shortcuts");
}

export function PinnedStatuses() {
  return import("../../pinned_statuses");
}

export function AccountTimeline() {
  return import("../../account_timeline");
}

export function AccountGallery() {
  return import("../../account_gallery");
}

export function AccountFeatured() {
  return import("../../account_featured");
}

export function AccountEdit() {
  return import("../../account_edit").then((module) => ({ default: module.AccountEdit }));
}

export function AccountEditFeaturedTags() {
  return import("../../account_edit/featured_tags").then((module) => ({
    default: module.AccountEditFeaturedTags,
  }));
}

export function Followers() {
  return import("../../followers");
}

export function Following() {
  return import("../../following");
}

export function Reblogs() {
  return import("../../reblogs");
}

export function Favourites() {
  return import("../../favourites");
}

export function Quotes() {
  return import("../../quotes");
}

export function FollowRequests() {
  return import("../../follow_requests");
}

export function FavouritedStatuses() {
  return import("../../favourited_statuses");
}

export function FollowedTags() {
  return import("../../followed_tags");
}

export function BookmarkedStatuses() {
  return import("../../bookmarked_statuses");
}

export function Blocks() {
  return import("../../blocks");
}

export function DomainBlocks() {
  return import("../../domain_blocks");
}

export function Mutes() {
  return import("../../mutes");
}

export function MuteModal() {
  return import("../components/mute_modal");
}

export function BlockModal() {
  return import("../components/block_modal");
}

export function DomainBlockModal() {
  return import("../components/domain_block_modal");
}

export function ReportModal() {
  return import("../components/report_modal");
}

export function SettingsModal() {
  return import("../../local_settings");
}

export function ReportCollectionModal() {
  return import("../components/report_collection_modal").then((module) => ({
    default: module.ReportCollectionModal,
  }));
}

export function IgnoreNotificationsModal() {
  return import("../components/ignore_notifications_modal");
}

export function MediaGallery() {
  return import("../../../components/media_gallery");
}

export function Video() {
  return import("../../video");
}

export function EmbedModal() {
  return import("../components/embed_modal");
}

export function ListAdder() {
  return import("../../list_adder");
}

export function Tesseract() {
  return import("tesseract.js");
}

export function Audio() {
  return import("../../audio");
}

export function Directory() {
  return import("../../directory");
}

export function OnboardingProfile() {
  return import("../../onboarding/profile");
}

export function OnboardingFollows() {
  return import("../../onboarding/follows");
}

export function CompareHistoryModal() {
  return import("../components/compare_history_modal");
}

export function Explore() {
  return import("../../explore");
}

export function Search() {
  return import("../../search");
}

export function FilterModal() {
  return import("../components/filter_modal");
}

export function InteractionModal() {
  return import("../../interaction_modal");
}

export function SubscribedLanguagesModal() {
  return import("../../subscribed_languages_modal");
}

export function ClosedRegistrationsModal() {
  return import("../../closed_registrations_modal");
}

export function About() {
  return import("../../about");
}

export function PrivacyPolicy() {
  return import("../../privacy_policy");
}

export function TermsOfService() {
  return import("../../terms_of_service");
}

export function NotificationRequests() {
  return import("../../notifications/requests");
}

export function NotificationRequest() {
  return import("../../notifications/request");
}

export function LinkTimeline() {
  return import("../../link_timeline");
}

export function AnnualReportModal() {
  return import("../../annual_report/modal");
}

export function ListEdit() {
  return import("../../lists/new");
}

export function ListMembers() {
  return import("../../lists/members");
}
export function CommunityDirectoryAdmin() {
  return Promise.resolve(import("../../community_directory/admin/index"))
    .then((module) => {
      return {
        default: module.default || module.CommunityDirectoryAdmin || module,
      };
    })
    .catch((err) => {
      console.error("Failed to load CommunityDirectoryAdmin:", err);
      throw err;
    });
}

export function CommunityDirectory() {
  return import("../../community_directory");
}

export function CommunityDirectoryFormBuilder() {
  return import("../../community_directory/admin");
}

export function CommunityDirectoryEdit() {
  return import("../../community_directory/edit");
}

export function CommunityDirectoryModeration() {
  return import("../../community_directory/moderation");
}

export function CommunityDirectoryPermissions() {
  return import("../../community_directory/permissions");
}

export function CommunityDirectoryScraperLogs() {
  return import("../../community_directory/scraper_logs");
}
export function CommunityDirectoryLocations() {
  return import("../../community_directory/locations");
}
export function CommunityArtists() {
  return import("../../community_artists");
}
export function CommunityMaintenance() {
  return import("../../community_maintenance");
}

export function CommunityVisits() {
  return import("../../community_visits");
}

export function CommunityVisitsNotifications() {
  return import("../../community_visits/notifications");
}

export function CommunityVisitsAdmin() {
  return import("../../community_visits/admin");
}

export function CommunityListings() {
  return import("../../community_listings");
}

export function CommunityListingsShow() {
  return import("../../community_listings/show");
}

export function CommunityListingsNew() {
  return import("../../community_listings/new");
}

export function CommunityListingsEdit() {
  return import("../../community_listings/edit");
}

export function CommunityArtistsShow() {
  return import("../../community_artists/show");
}

export function CommunityArtistsNew() {
  return import("../../community_artists/new");
}

export function CommunityServices() {
  return import("../../community_services");
}

export function CommunityServicesShow() {
  return import("../../community_services/show");
}

export function CommunityServicesNew() {
  return import("../../community_services/new");
}

export function CommunityServicesEdit() {
  return import("../../community_services/edit");
}

export function CommunityRestaurants() {
  return import("../../community_restaurants");
}

export function CommunityRestaurantsShow() {
  return import("../../community_restaurants/show");
}

export function CommunityRestaurantsNew() {
  return import("../../community_restaurants/new");
}

export function CommunityRestaurantsEdit() {
  return import("../../community_restaurants/edit");
}

export function CommunityProperties() {
  return import("../../community_properties");
}

export function CommunityPropertiesShow() {
  return import("../../community_properties/show");
}

export function CommunityPropertiesNew() {
  return import("../../community_properties/new");
}

export function CommunityPropertiesEdit() {
  return import("../../community_properties/edit");
}

export function CommunityDirectoryEntries() {
  return import("../../community_directory/entries");
}

// [CD:ASYNC_EXPORTS]

export function CommunityArtistsEdit() {
  return import("../../community_artists/edit");
}

export function CommunityEvents() {
  return import("../../community_events");
}

export function CommunityEventsShow() {
  return import("../../community_events/show");
}

export function CommunityEventsNew() {
  return import("../../community_events/new");
}

export function CommunityEventsEdit() {
  return import("../../community_events/edit");
}

export function CommunityLanding() {
  return import("../../community_landing");
}

export function CommunityLandingSettings() {
  return import("../../community_directory/landing_settings");
}

export function MemberStories() {
  return import("../../member_stories");
}

export function MemberStoriesShow() {
  return import("../../member_stories/show");
}

export function MemberStoriesEdit() {
  return import("../../member_stories/edit");
}

export function ContactPage() {
  return import("../../contact");
}

export function DailyDigest() {
  return import("../../daily_digest");
}

export function NewsletterIndex() {
  return import("../../newsletters");
}

export function NewsletterShow() {
  return import("../../newsletters/show");
}

export function QuickShareIndex() {
  return import("../../quick_shares");
}

export function QuickShareNew() {
  return import("../../quick_shares/new");
}

export function QuickShareShow() {
  return import("../../quick_shares/show");
}

export function NotificationSettings() {
  return import("../../notification_settings");
}

export function CommunityEntryNotifications() {
  return import("../../community_entry_notifications");
}

export function HowItWorks() {
  return import("../../how_it_works");
}
